module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatDisorder/Nagano_HeatDisorder_MRI_RCP45_End.png";